import { QueryKey } from '@tanstack/react-query';
import omit from 'lodash/omit';
import { BookingRequestsService } from '../../api';
import { DefaultQueryKeyFactory, QueryKeyFactoryGenerator } from '../../utils/query-keys-factory';

export const bookingRequestsQueryKeys = new QueryKeyFactoryGenerator<
  DefaultQueryKeyFactory,
  {
    history: (
      params: Parameters<typeof BookingRequestsService.bookingRequestsHistoryList>[0]
    ) => QueryKey;
    fileAttachments: (request_id: string) => QueryKey;
    extra: (requestId: string) => QueryKey;
  }
>('booking_requests', {
  history: (
    params: Parameters<typeof BookingRequestsService.bookingRequestsHistoryList>[0]
  ): QueryKey => [
    ...bookingRequestsQueryKeys.allDetails(),
    params.requestId,
    'history',
    omit(params, 'requestId'),
  ],
  fileAttachments: (request_id: string): QueryKey => [
    ...bookingRequestsQueryKeys.allDetails(),
    request_id,
    'file_attachments',
  ],
  extra: (requestId: string): QueryKey => [
    ...bookingRequestsQueryKeys.allDetails(),
    requestId,
    'extra',
  ],
}).getDefault<typeof BookingRequestsService.bookingRequestsList, string>();
